import Vue from 'vue'
import VueResource from 'vue-resource'
import datePicker from '../../component/dccore-form/datePicker.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import VueNumericInput from 'vue-numeric-input'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import DcCoreSingleSelect from '../../component/dccore-form/singleselect.vue'
import ErrorBlock from '../../component/simple-form/ErrorBlock.vue'
import moment from 'moment'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import Datepicker from 'vuejs-datepicker'
import userFinder from '../../component/dccore-form/userFinder.vue'
import toastr from '../toastr'

if ($('#withdrawal_form').length) {
  let entityId = $('#entity_id').val()
  if (typeof entityId === 'undefined') {
    entityId = null
  }
  Vue.use(VueResource)
  new Vue({
    el: '#withdrawal_form',
    components: {
      datePicker,
      RingLoader,
      VueNumericInput,
      Singleselect,
      ErrorBlock,
      NumberInput,
      TextInput,
      Checkbox,
      Datepicker,
      DcCoreSingleSelect,
      userFinder
    },
    data: {
      loading: 0,
      entityId: entityId,
      errors: {},
      client: null,
      disable: false,
      userBtnText: 'Znajdź użytkownika',
      isFinalized: false,
      maxFromWallet: 0,
      redirectAfterAccept: 0,
      entity: {
        issueDate: moment().toDate(),
        value: 0,
        user: null,
        firstName: null,
        lastName: null,
        accountNumber: null,
        finalized: false,
        canceled: false
      }
    },
    computed: {
      maxWallet: function () {
        if (this.client !== null) {
          return this.client.wallet
        }
        return 0
      },
      canCancel: function () {
        return this.entityId !== null && !this.isFinalized
      }
    },
    watch: {
      client: function (newValue) {
        if (newValue !== null) {
          this.entity.firstName = newValue.firstName
          this.entity.lastName = newValue.lastName
          this.entity.user = newValue.id
          this.entity.value = newValue.wallet
          this.userBtnText = 'Zmień użytkownika'
          this.maxFromWallet = newValue.wallet
          this.errors = {}
        }
      },
      'entity.value': function (newValue) {
        if (this.entityId !== null) {
          return
        }
        if (newValue > this.maxWallet) {
          this.entity.value = this.maxWallet
          newValue = this.maxWallet
          toastr.info(`Maksymalna kwota zwrotu wynosi ${this.maxWallet}`)
        }
        this.entity.value = Math.round(this.entity.value * 100) / 100
      },
      'entity.issueDate': function (newValue) {
        this.entity.issueDate = moment(newValue).format('YYYY-MM-DD')
      }
    },
    mounted() {
      // this.getClients();
      if (this.entityId !== null) {
        this.getEntity()
      }
    },
    methods: {
      setUser: function(user) {
        if (typeof user === 'string' || user === null) {
          toastr.info('Nie znaleziono takiego użytkownika')
          return
        }
        this.client = user
      },
      getEntity() {
        this.loading++
        this.disable = true
        let url = Routing.generate('api_get_withdrawal', { withdrawal: this.entityId })
        this.$http.get(url).then(response => {
          this.entity = response.data
          this.isFinalized = this.entity.finalized
          this.loading--
        }, response => {
          this.handleAjaxError(response)
          this.loading--
        })
      },
      cancelWithdrawal() {
        this.closeAcceptCancelModal()
        let url = Routing.generate('api_cancel_withdrawal', { withdrawal: this.entityId })
        this.loading++
        this.$http.post(url).then(() => {
          this.loading--
          this.getEntity()
          toastr.success('Anulowanie zakończone powodzeniem')
        }, res => {
          this.handleAjaxError(res)
          this.loading--
        })
      },
      createWithdrawal() {
        let url = Routing.generate('api_post_withdrawal')
        this.$http.post(url, this.entity).then(() => {
          window.location.href = Routing.generate('withdrawal_grid')
          this.errors = {}
        }, response => {
          this.errors = response.data.errors
        })
      },
      showAcceptFinalizeModal(redirect) {
        this.redirectAfterAccept = redirect
        $('#finalizeModal').modal()
      },
      showAcceptCancelModal() {
        $('#cancelModal').modal()
      },
      closeAcceptFinalizeModal() {
        $('#finalizeModal').modal('hide')
      },
      closeAcceptCancelModal() {
        $('#cancelModal').modal('hide')
      },
      updateWithdrawal(redirect, showPopup = 1) {
        this.closeAcceptFinalizeModal()
        let url = Routing.generate('api_patch_withdrawal', { withdrawal: this.entityId })
        let data = this.entity
        if (this.entity.user !== null && typeof this.entity.user === 'object') {
          data.user = this.entity.user.id
        }
        if (showPopup === 1 && this.entity.finalized === true && !this.isFinalized) {
          this.showAcceptFinalizeModal(redirect)
          return
        }
        this.loading++
        this.$http.patch(url, data).then(() => {
          if (redirect === 1) {
            window.location.href = Routing.generate('withdrawal_show', { withdrawal: this.entityId })
          } else {
            this.getEntity()
            toastr.success('Aktualizacja zakończona powodzeniem')
          }
          this.errors = {}
          this.loading--
        }, res => {
          this.handleAjaxError(res)
          this.errors = res.data.errors
          this.loading--
        })
      }
    }
  })
}
